import { createContext, useContext } from 'react';

export const ModalTopStackItemContext = createContext(true);

export const useIsTopModal = () => useContext(ModalTopStackItemContext);
